import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListChargePointNameCell } from './channel-list-charge-point-name.cell';
import { ChannelListChargePointNameHeader } from './channel-list-charge-point-name.header';

export const ChannelListChargePointNameColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['chargePointModel']
> = {
  enableSorting: false,
  header: ChannelListChargePointNameHeader,
  cell: ChannelListChargePointNameCell,
};
